import React from "react";

import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { PhotoUploadBlock, PhotoUploadResponse } from "../types";

interface Props {
  question: PhotoUploadBlock;
  response: PhotoUploadResponse;
}

const useStyles = makeStyles()({
  image: {
    aspectRatio: 16 / 10,
    height: 200,
    objectFit: "cover",
  },
});

const PhotoUpload: React.FC<Props> = ({ question, response }) => {
  const { classes } = useStyles();
  return (
    <Box>
      <Box fontSize={14} fontWeight="600" color="#7D8797">
        {question.data.title}
      </Box>
      <Box mt="12px" display="flex" gap="8px">
        {response.files.map((url) => (
          <img key={url} className={classes.image} src={url} />
        ))}
      </Box>
    </Box>
  );
};

export default PhotoUpload;
